import React from 'react'
import { Button, Grid, Typography } from '@material-ui/core'
import { Form, Formik } from 'formik'
import HighlightOffIcon from '@material-ui/icons/HighlightOff'
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline'

import { SiloDestinoParaTransileSelect } from '../SiloDestinoParaTransileSelect/SiloDestinoParaTransileSelect'
import { TRANSILE_SCHEMA } from './constants'

export const OperacionNuevoTransileView = ({ siloOrigen, aceptar, cancelar, ...cerealYVariedad }) => (
  <Formik initialValues={{ siloDestino: '' }} onSubmit={aceptar} validationSchema={TRANSILE_SCHEMA}>
    {({ isSubmitting, isValid }) => (
      <Form>
        <Grid container spacing={2} direction='column' justify='space-between'>
          <Grid item>
            <Typography variant='h6'>Transile desde {siloOrigen}</Typography>
          </Grid>
          <Grid item>
            <SiloDestinoParaTransileSelect {...cerealYVariedad} />
          </Grid>
          <Grid container item spacing={2} justify='space-between'>
            <Grid item xs='auto'>
              <Button
                variant='contained'
                color='secondary'
                disabled={isSubmitting}
                startIcon={<HighlightOffIcon />}
                onClick={cancelar}>
                Cancelar
              </Button>
            </Grid>
            <Grid item xs='auto'>
              <Button
                variant='contained'
                color='primary'
                disabled={isSubmitting || !isValid}
                startIcon={<CheckCircleOutlineIcon />}
                type='submit'>
                Aceptar
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Form>
    )}
  </Formik>
)
